define("discourse/plugins/discourse-patreon/discourse/controllers/admin-plugins-patreon", ["exports", "@ember/controller", "I18n", "discourse-common/utils/decorators", "discourse-common/lib/get-url", "discourse/plugins/discourse-patreon/discourse/models/filter-rule", "discourse/lib/ajax", "discourse/lib/ajax-error", "bootbox"], function (_exports, _controller, _I18n, _decorators, _getUrl, _filterRule, _ajax, _ajaxError, _bootbox) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend((_dec = (0, _decorators.default)("rewards"), (_obj = {
    prettyPrintReward: function prettyPrintReward(reward) {
      return "$".concat(reward.amount_cents / 100, " - ").concat(reward.title);
    },
    rewardsNames: function rewardsNames() {
      var _this = this;

      return Object.values(this.rewards).filter(function (r) {
        return r.id >= 0;
      }).map(function (r) {
        return _this.prettyPrintReward(r);
      });
    },
    editing: _filterRule.default.create({
      group_id: null
    }),
    actions: {
      save: function save() {
        var _this2 = this;

        var rule = this.get("editing");
        var model = this.get("model");
        rule.set("group", this.groups.find(function (x) {
          return x.id === parseInt(rule.get("group_id"), 10);
        }));
        rule.set("rewards_ids", Object.values(this.rewards).filter(function (v) {
          return rule.get("reward_list").includes(_this2.prettyPrintReward(v));
        }).map(function (r) {
          return r.id;
        }));
        (0, _ajax.ajax)("/patreon/list.json", {
          method: "POST",
          data: rule.getProperties("group_id", "rewards_ids")
        }).then(function () {
          var obj = model.find(function (x) {
            return x.get("group_id") === rule.get("group_id");
          });
          var rewards = rule.get("reward_list").filter(Boolean);

          if (obj) {
            obj.set("reward_list", rewards);
            obj.set("rewards", rewards);
            obj.set("rewards_ids", rule.rewards_ids);
          } else {
            model.pushObject(_filterRule.default.create({
              group: rule.get("group.name"),
              rewards: rewards
            }));
          }

          _this2.set("editing", _filterRule.default.create({
            group_id: null
          }));
        }).catch(_ajaxError.popupAjaxError);
      },
      delete: function _delete(rule) {
        var model = this.get("model");
        (0, _ajax.ajax)("/patreon/list.json", {
          method: "DELETE",
          data: rule.getProperties("group_id")
        }).then(function () {
          var obj = model.find(function (x) {
            return x.get("group_id") === rule.get("group_id");
          });
          model.removeObject(obj);
        }).catch(_ajaxError.popupAjaxError);
      },
      updateData: function updateData() {
        var _this3 = this;

        this.set("updatingData", true);
        (0, _ajax.ajax)("/patreon/update_data.json", {
          method: "POST"
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          return _this3.set("updatingData", false);
        });
        this.messageBus.subscribe("/patreon/background_sync", function () {
          _this3.messageBus.unsubscribe("/patreon/background_sync");

          _this3.set("updatingData", false);

          _bootbox.default.alert(_I18n.default.t("patreon.refresh_page"), function () {
            window.location.pathname = (0, _getUrl.default)("/admin/plugins/patreon");
          });
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "rewardsNames", [_dec], Object.getOwnPropertyDescriptor(_obj, "rewardsNames"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-patreon/discourse/initializers/patreon", ["exports", "discourse/lib/plugin-api"], function (_exports, _pluginApi) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var numTopicsOpened = 0;
  var cookieName = "PatreonDonationPromptClosed";

  function initWithApi(api) {
    var currentUser = api.getCurrentUser();
    api.onAppEvent("page:topic-loaded", function (topic) {
      if (!topic) {
        return;
      }

      var isPrivateMessage = topic.isPrivateMessage;

      if (!currentUser || isPrivateMessage) {
        return;
      }

      if (numTopicsOpened <= topic.siteSettings.patreon_donation_prompt_show_after_topics) {
        numTopicsOpened++;
      }
    });
    api.registerConnectorClass("topic-above-footer-buttons", "patreon", {
      shouldRender: function shouldRender(_args, component) {
        return component.currentUser;
      },
      setupComponent: function setupComponent(_args, component) {
        component.didInsertElement = function () {
          var showDonationPrompt = this.siteSettings.patreon_enabled && this.siteSettings.patreon_donation_prompt_enabled && this.siteSettings.patreon_donation_prompt_campaign_url !== "" && this.currentUser.show_donation_prompt && $.cookie(cookieName) !== "t" && numTopicsOpened > this.siteSettings.patreon_donation_prompt_show_after_topics;
          this.set("showDonationPrompt", showDonationPrompt);
        };
      },
      actions: {
        close: function close() {
          // hide the donation prompt for 30 days
          var expires = moment().add(30, "d").toDate();
          $.cookie(cookieName, "t", {
            expires: expires
          });
          this.$().fadeOut(700);
        }
      }
    });
  }

  var _default = {
    name: "patreon",
    initialize: function initialize() {
      (0, _pluginApi.withPluginApi)("0.8", initWithApi);
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-patreon/discourse/models/filter-rule", ["exports", "discourse/models/rest"], function (_exports, _rest) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _rest.default.extend({
    group_id: -1,
    reward_list: ""
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-patreon/discourse/patreon-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: "admin.adminPlugins",
    path: "/plugins",
    map: function map() {
      this.route("patreon");
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-patreon/discourse/routes/admin-plugins-patreon", ["exports", "discourse/lib/ajax-error", "discourse/models/group", "discourse/lib/ajax", "discourse/plugins/discourse-patreon/discourse/models/filter-rule", "discourse/routes/discourse", "rsvp"], function (_exports, _ajaxError, _group, _ajax, _filterRule, _discourse, _rsvp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  /* We use three main model to get this page working:
   *  Discourse Groups (excluding the automatic ones), Patreon rewards and
   *  and current filters (one filter is a tuple between 1 Discourse group and N Patreon rewards)
   */
  var _default = _discourse.default.extend({
    model: function model() {
      return _rsvp.Promise.all([(0, _ajax.ajax)("/patreon/list.json"), _group.default.findAll({
        ignore_automatic: true
      })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            result = _ref2[0],
            groups = _ref2[1];

        groups = groups.map(function (g) {
          return {
            id: g.id,
            name: g.name
          };
        });
        return {
          filters: result.filters,
          rewards: result.rewards,
          last_sync_at: result.last_sync_at,
          groups: groups
        };
      }).catch(_ajaxError.popupAjaxError);
    },
    setupController: function setupController(controller, model) {
      var rewards = model.rewards;
      var groups = model.groups;
      var filtersArray = Object.entries(model.filters).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];

        var rewardsNames = v.map(function (r) {
          return rewards[r] ? " $".concat(rewards[r].amount_cents / 100, " - ").concat(rewards[r].title) : "";
        });
        var group = groups.find(function (g) {
          return g.id === parseInt(k, 10);
        });
        return _filterRule.default.create({
          group: group.name,
          rewards: rewardsNames,
          group_id: k,
          reward_ids: v
        });
      });
      controller.setProperties({
        model: filtersArray,
        groups: groups,
        rewards: rewards,
        last_sync_at: model.last_sync_at
      });
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/admin/plugins-patreon"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"rule\"],\"statements\":[[7,\"section\",true],[10,\"id\",\"patreon\"],[8],[0,\"\\n  \"],[7,\"h1\",true],[8],[1,[28,\"i18n\",[\"patreon.header.rules\"],null],false],[9],[0,\"\\n  \"],[7,\"table\",true],[8],[0,\"\\n    \"],[7,\"thead\",true],[8],[0,\"\\n      \"],[7,\"tr\",true],[8],[0,\"\\n        \"],[7,\"th\",true],[8],[1,[28,\"i18n\",[\"patreon.group\"],null],false],[9],[0,\"\\n        \"],[7,\"th\",true],[8],[1,[28,\"i18n\",[\"patreon.rewards\"],null],false],[9],[0,\"\\n        \"],[7,\"th\",true],[8],[9],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\\n    \"],[7,\"tbody\",true],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"model\"]]],null,{\"statements\":[[0,\"        \"],[7,\"tr\",true],[10,\"class\",\"\"],[8],[0,\"\\n          \"],[7,\"td\",true],[8],[1,[23,1,[\"group\"]],false],[9],[0,\"\\n          \"],[7,\"td\",true],[8],[1,[23,1,[\"rewards\"]],false],[9],[0,\"\\n          \"],[7,\"td\",true],[8],[0,\"\\n            \"],[7,\"div\",true],[10,\"class\",\"pull-right\"],[8],[0,\"\\n              \"],[1,[28,\"d-button\",null,[[\"action\",\"actionParam\",\"icon\",\"class\",\"title\"],[\"delete\",[23,1,[]],\"far-trash-alt\",\"delete btn-danger\",\"patreon.delete\"]]],false],[0,\"\\n            \"],[9],[0,\"\\n          \"],[9],[0,\"\\n        \"],[9],[0,\"\\n\"]],\"parameters\":[1]},null],[0,\"    \"],[9],[0,\"\\n\\n    \"],[7,\"tfoot\",true],[8],[0,\"\\n      \"],[7,\"tr\",true],[10,\"class\",\"new-filter\"],[8],[0,\"\\n        \"],[7,\"td\",true],[8],[1,[28,\"combo-box\",null,[[\"value\",\"content\",\"nameProperty\",\"valueProperty\",\"none\"],[[24,[\"editing\",\"group_id\"]],[24,[\"groups\"]],\"name\",\"id\",\"patreon.select_group\"]]],false],[9],[0,\"\\n        \"],[7,\"td\",true],[8],[1,[28,\"list-setting\",null,[[\"value\",\"choices\",\"class\"],[[24,[\"editing\",\"reward_list\"]],[24,[\"rewardsNames\"]],\"rewards\"]]],false],[9],[0,\"\\n        \"],[7,\"td\",true],[8],[0,\"\\n          \"],[7,\"div\",true],[10,\"class\",\"pull-right\"],[8],[0,\"\\n            \"],[1,[28,\"d-button\",null,[[\"action\",\"icon\",\"class\",\"title\"],[\"save\",\"check\",\"save btn-primary\",\"patreon.save\"]]],false],[0,\"\\n          \"],[9],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n\\n  \"],[7,\"p\",true],[8],[1,[28,\"i18n\",[\"patreon.help_text\"],null],false],[9],[0,\"\\n\\n  \"],[1,[28,\"d-button\",null,[[\"action\",\"icon\",\"class\",\"disabled\",\"title\",\"label\"],[\"updateData\",\"refresh\",\"test\",[24,[\"updatingData\"]],\"patreon.update_data\",\"patreon.update_data\"]]],false],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"last_sync_at\"]]],null,{\"statements\":[[0,\"    \"],[7,\"span\",true],[10,\"class\",\"last_synced\"],[8],[1,[28,\"i18n\",[\"patreon.last_synced\"],null],false],[0,\": \"],[1,[28,\"html-safe\",[[28,\"format-date\",[[24,[\"last_sync_at\"]]],[[\"leaveAgo\"],[\"true\"]]]],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/admin/plugins-patreon"}});
Ember.TEMPLATES["javascripts/connectors/admin-user-details/patreon"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"section\",true],[10,\"class\",\"details\"],[8],[0,\"\\n  \"],[7,\"h1\",true],[8],[1,[28,\"i18n\",[\"patreon.title\"],null],false],[9],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.id\"],null],false],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[1,[24,[\"model\",\"patreon_id\"]],false],[9],[0,\"\\n  \"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"model\",\"patreon_email_exists\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.email\"],null],false],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"patreon_email\"]]],null,{\"statements\":[[0,\"          \"],[1,[22,\"patreon_email\"],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"          \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"icon\",\"label\",\"title\"],[\"btn-default\",\"checkPatreonEmail\",[24,[\"model\"]],\"far-envelope\",\"admin.users.check_email.text\",\"admin.users.check_email.title\"]]],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"model\",\"patreon_amount_cents\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.amount_cents\"],null],false],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[1,[24,[\"model\",\"patreon_amount_cents\"]],false],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"model\",\"patreon_rewards\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.rewards\"],null],false],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[1,[24,[\"model\",\"patreon_rewards\"]],false],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"model\",\"patreon_declined_since\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.declined_since\"],null],false],[9],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[1,[28,\"html-safe\",[[24,[\"format-date\"]],[24,[\"model\",\"patreon_declined_since\"]]],null],false],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"  \"],[7,\"div\",true],[10,\"class\",\"display-row\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"field\"],[8],[1,[28,\"i18n\",[\"patreon.field.more_details.label\"],null],false],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"value\"],[8],[0,\"\\n      \"],[7,\"a\",true],[10,\"rel\",\"noopener noreferrer\"],[10,\"target\",\"_blank\"],[11,\"href\",[22,\"patron_url\"]],[8],[0,\"\\n        \"],[1,[28,\"d-icon\",[\"external-link-alt\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"model\",\"patreon_email\"]]],null,{\"statements\":[[0,\"        \"],[1,[28,\"i18n\",[\"patreon.field.more_details.help_text.email_available\"],null],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"        \"],[1,[28,\"i18n\",[\"patreon.field.more_details.help_text.email_not_available\"],null],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/connectors/admin-user-details/patreon"}});
define("discourse/plugins/discourse-patreon/discourse/templates/connectors/admin-user-details/patreon", ["exports", "discourse/lib/ajax", "discourse/lib/url"], function (_exports, _ajax, _url) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    shouldRender: function shouldRender(args, component) {
      component.args.patron_url = "https://patreon.com/members";
      return component.siteSettings.patreon_enabled && args.model.patreon_id;
    },
    actions: {
      checkPatreonEmail: function checkPatreonEmail(user) {
        var _this = this;

        (0, _ajax.ajax)((0, _url.userPath)("".concat(user.username_lower, "/patreon_email.json")), {
          data: {
            context: window.location.pathname
          }
        }).then(function (result) {
          if (result) {
            var email = result.email;
            var url = "https://patreon.com/members";

            if (email) {
              url = "".concat(url, "?query=").concat(email);
            }

            _this.set("patreon_email", email);

            _this.set("patron_url", url);
          }
        });
      }
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/connectors/topic-above-footer-buttons/patreon"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"showDonationPrompt\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"patreon-donation-prompt\"],[8],[0,\"\\n    \"],[7,\"span\",false],[12,\"role\",\"button\"],[12,\"class\",\"close\"],[3,\"action\",[[23,0,[]],\"close\"]],[8],[0,\"\\n      \"],[1,[28,\"d-icon\",[\"times\"],null],false],[0,\"\\n    \"],[9],[0,\"\\n\\n    \"],[1,[28,\"html-safe\",[[28,\"i18n\",[\"patreon.donation_prompt.body\"],[[\"campaignUrl\"],[[24,[\"siteSettings\",\"patreon_donation_prompt_campaign_url\"]]]]]],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/connectors/topic-above-footer-buttons/patreon"}});

